module.exports = __webpack_public_path__ + "img/step-2-bus.305934a1.svg";